import { Button } from '@ui/themed';
import type { ReactNode } from 'react';
import { SettingRow } from './setting-row';

export function SettingActionRow({
  label,
  description,
  learnMoreUrl,
  actionLabel,
  onAction,
  disabled = false,
  tooltip,
}: {
  label: ReactNode;
  description?: ReactNode;
  learnMoreUrl?: string;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
  tooltip?: string;
}) {
  return (
    <SettingRow
      label={label}
      description={description}
      learnMoreUrl={learnMoreUrl}
      tooltip={tooltip}
      align="center"
      control={
        <Button variant="secondary" onClick={onAction} disabled={disabled}>
          {actionLabel}
        </Button>
      }
    />
  );
}
